import { render, staticRenderFns } from "./productWrapper.vue?vue&type=template&id=1817211a&scoped=true&"
import script from "./productWrapper.vue?vue&type=script&lang=js&"
export * from "./productWrapper.vue?vue&type=script&lang=js&"
import style0 from "./productWrapper.vue?vue&type=style&index=0&id=1817211a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1817211a",
  null
  
)

export default component.exports